import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { ActivityRepository } from '@/store/activity-state/activity-state.repository';

interface IgetActivityDataTableStructureProps {
  store: ActivityRepository;
  rowActions?: DataTableRowActions;
  createAction?: () => void;
  enableServerActions?: boolean;
  serverQuery?: any;
}

export const getActivityDataTableStructure = ({
  store,
  rowActions,
  enableServerActions,
  serverQuery,
  createAction,
}: IgetActivityDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.activity.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const libelleColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.activity.table.libelle',
    accessorKey: 'libelle',
    variant: DataTableColumnVariant.TEXT,
  };
  const categorieActiviteColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.activity.table.categorieActivite',
    accessorKey: 'categorieActivite.description',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.activity.table.singular',
    plural: 'settings.activity.table.plural',
    columns: [idColumn, libelleColumn, categorieActiviteColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('serverState', {
        libelle: row.libelle,
        categorieActiviteId: row.categorieActivite.id,
      });
      store.set('dto', {
        libelle: row.libelle,
        categorieActiviteId: row.categorieActivite.id,
      });
      store.set('activityCategorySelected', {
        name: row.categorieActivite.description,
        code: row.categorieActivite.id,
      });
    },
    createAction,
    rowActions,
    enableServerActions,
    serverQuery,
  };
};
